import { __assign, __rest } from "tslib";
import classNames from 'classnames';
import React from 'react';
import styles from './checkbox.module.css';
export var CheckboxCard = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.checked, checked = _d === void 0 ? false : _d, _e = _a.alignCheckbox, alignCheckbox = _e === void 0 ? 'start' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, children = _a.children, props = __rest(_a, ["checked", "alignCheckbox", "disabled", "children"]);
    var nativeProps = __assign(__assign({}, props), { children: void 0, cardtype: void 0, checkicon: void 0 });
    var customStyles = {
        left: alignCheckbox !== 'end' ? '15px' : 'auto',
        right: alignCheckbox === 'end' ? '15px' : 'auto',
    };
    return (React.createElement("div", { className: classNames(styles.checkboxCardContainer, (_b = {}, _b[styles.checked] = checked, _b[styles.disabled] = disabled, _b), "kplr_checkboxCardContainer") },
        React.createElement("div", { className: classNames(styles.baseCheckboxOuter, styles.checkboxCardOuter) },
            React.createElement("input", __assign({ type: "checkbox" }, nativeProps, { ref: ref, checked: checked, disabled: disabled })),
            React.createElement("div", { className: classNames(styles.baseCheckboxInner, styles.checkboxCardInner, styles[alignCheckbox]) },
                React.createElement("div", { style: customStyles, className: classNames(styles.baseCheckboxElement, styles.checkboxCardElement, (_c = {}, _c[styles.checked] = checked, _c[styles.disabled] = disabled, _c)) }),
                React.createElement("div", { className: styles.checkboxCardContent }, children)))));
});
CheckboxCard.displayName = 'CheckboxCard';
export default CheckboxCard;
